export default {
  default: () => import("/root/workspace/easyfun_web_UkvO/layouts/default.vue").then(m => m.default || m)
}